"use client"
import CommentTypes from "@/types/comment";
import Stack from "@mui/material/Stack";
import PComment from "./p-comment";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {Collapse} from "@mui/material";
import PContentSection from "./p-content-section";
import React, {useState} from "react";
import PStars from "./p-stars";
import PCommentDialog from "./p-comment-dialog";
import useRedirectToLogin from "@/hooks/useRedirectToLogin";
import {useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";
import FaIcon from "@/components/utilities/fa-icon";

export default function PCommentsSection({comments, productId,mutateProduct}: {
    comments: Array<CommentTypes>; productId: number;
    mutateProduct: () => void;
}) {
    const [selectedStars, setSelectedStars] = useState<number | undefined>();
    const [commentDialogOpen, setCommentDialogOpen] = useState<boolean>(false);
    const redirectToLogin = useRedirectToLogin()
    const user = useAppSelector((state: RootState) => state.user.currentUser)
    const [showAll, setShowAll] = useState<boolean>(false);

    const handleCommentDialogClose = () => {
        setCommentDialogOpen(false);
        setSelectedStars(undefined);
    };

    return (
        <PContentSection
            subtitle={comments?.length ? `${comments?.length} نظر` : undefined}
            faIcon = "fa-comment-alt"
            title = "نظرات کاربران و امتیاز"
            name = "نظرات"
        >
            <Box
                my={2}
                display="flex"
                gap={2.5}
                flexDirection={{md: 'row', xs: 'column'}}
                justifyContent={{md: 'space-between', xs: 'center'}}
            >
                    <PStars
                        onClick = {(i) => {
                            if (user) {
                                setSelectedStars(i);
                                setCommentDialogOpen(true);
                            } else {
                                redirectToLogin()
                            }

                        }}
                        fixedRating = {selectedStars}
                    />

                <Button
                    onClick = {() => {
                        if (user) {
                            setCommentDialogOpen(true);
                        } else {
                            redirectToLogin()
                        }
                    }}
                    variant = "outlined"
                    size = "small"
                >
                    {user ? `نظری دارید؟‌ کلیک کنید`: `نظری دارید؟‌ ابتدا وارد شوید`}

                </Button >

                <PCommentDialog
                    productId = {productId}
                    selectedStars = {selectedStars}
                    setSelectedStars = {setSelectedStars}
                    open = {commentDialogOpen}
                    handleClose = {handleCommentDialogClose}
                    mutateProduct={mutateProduct}
                />

            </Box >

            <Stack direction ="column" >
                {comments.slice(0, 3).map((comment) => (
                    <React.Fragment key = {comment.id} >
                        <PComment comment = {comment} />
                    </React.Fragment >
                ))}

                {comments.length > 3 && (
                    <>
                        <Collapse in = {showAll} >
                            {comments.slice(3).map((comment) => (
                                <React.Fragment key = {comment.id} >
                                    <PComment comment = {comment} />
                                </React.Fragment >
                            ))}
                        </Collapse >

                            <Button
                                fullWidth
                                onClick = {() => {
                                    setShowAll(!showAll);
                                }}
                                sx={{
                                    display : "flex",
                                    justifyContent : "center",
                                    alignItems : "center",
                                    mt:1
                                }}
                                startIcon = {
                                    <FaIcon
                                        variant="solid"
                                        fontSize={16}
                                        faIcon ={`fal fa-${!showAll ? "plus" : "minus"}`}
                                        sx={{
                                            pl:.5
                                        }}
                                    />
                                }
                            >

                                {showAll ? "نمایش خلاصه" : "نمایش همه"}
                            </Button >
                    </>
                ) }

            </Stack >
        </PContentSection >
    );
}
